import * as Sentry from '@sentry/react';

// Deploy environment (dev|uat|prod) for the Sentry `environment` tag.
//
// This deliberately does NOT read NODE_ENV. The Nx webpack executor forces
// `process.env['NODE_ENV'] ||= 'production'` on every build
// (@nx/webpack/src/executors/webpack/webpack.impl.js), so NODE_ENV tags a UAT
// deploy as `production` and there is no way to keep QA traffic out of the
// production dashboards. NX_PUBLIC_ENV is the deploy target injected by the
// workflows; it is spelled `UAT` in some and `uat` in others, hence the
// lowercase normalisation. NODE_ENV stays as a last resort so an app whose
// pipeline does not set NX_PUBLIC_ENV yet keeps its previous behaviour instead
// of reporting an empty environment.
export const resolveSentryEnvironment = () =>
  (process.env.NX_PUBLIC_ENV || process.env.NODE_ENV || '').toLowerCase() ||
  null;

const getRelease = () => {
  try {
    const version = require(process.env.NX_PUBLIC_PATH_APP + '/src/assets/scripts/.version').default;
    const productName = process.env.NX_PUBLIC_PRODUCT_NAME.toLowerCase().replaceAll(' ', '-');

    return productName ? `${productName}@${version}` : version;
  }
  catch (e) {
    return null;
  }
}

export const initSentry = (options = {}) => {
  const { release, tracePropagationTargets } = options;

  Sentry.init({
    dsn: process.env.NX_PUBLIC_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    environment: resolveSentryEnvironment(),
    release: release ?? getRelease(),
    tracePropagationTargets: tracePropagationTargets || ['localhost'],
  });
};

export const initSentryWithData = (sentryData) => {
  const {
    release: argsRelease,
    tracesSampleRate = 0.01,
    replaysSessionSampleRate = 0,
    replaysOnErrorSampleRate = 0.1,
    ...options
  } = sentryData || {};

  Sentry.init({
    dsn: process.env.NX_PUBLIC_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: resolveSentryEnvironment(),
    tracesSampleRate,
    replaysOnErrorSampleRate,
    replaysSessionSampleRate,
    ...options,
    release: argsRelease ?? getRelease(),
  });
};

export const captureException = (error) => {
  Sentry.captureException(error);
}

